/* eslint-disable no-lone-blocks */
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import disableBrowserBackButton from "disable-browser-back-navigation";
import xss from "xss";

import { Link, useNavigate } from "../utils/components/router";
import KundenCreateMA from "./KundenCreateMA";
import { kundenActions } from "../actions";
import { RAGE_RIGHT } from "../utils/enums";
import MALogin from "./MALogin";
import PageHeader from "./PageHeader";
import CONFIG from "../config";
import { CloseIcon, SearchIcon } from "../utils/components/icons";
import { isAuthenticated, console } from "../utils/functions";
import { ErrorMessage } from "./components";

class KundenRecordDataMA extends Component {
  constructor(props) {
    super(props);
    this.weiterleitung = this.weiterleitung.bind(this);
  }
  state = {
    // orderjson: [],
    // query: "",
    // results: [],
    search: null,
    isLoggedIn: false,
    error: null
  };

  componentDidMount = async () => {
    disableBrowserBackButton();
    
    if (this.props.basketStorage.isOverOrderLimit()) {
      this.props.navigate(this.props.configStorage.getBackToShopLink());
    }

    //#AnpassungKunde
    if (this.state.isLoggedIn) {
      let requestDataKundenEntry = this.props.configStorage.getRequestData("kunde");
      const loaded = await this.props.dispatch(kundenActions.fetchEntries(requestDataKundenEntry))
        .catch(err => {
          console.error("KundenRecordDataMa mount error", err);
          this.setState({ error: err });
        });
      console.log("KundenRecordDataMa mount", loaded);
      let editedKunde = this.props.kundenStorage.editedKunde;
      if (editedKunde.vorname !== undefined) {
        this.setState({ search: `${editedKunde.vorname} ${editedKunde.nachname}` });
      }
    }
    const preselectedKunde = this.props.authenticationStorage.kundenId;
    if (preselectedKunde) {
      this.weiterleitung(null, preselectedKunde);
    }
  };

  async handleEditKunde(e, kundenId) {
    if (e) e.preventDefault();
    let requestDataKundenEntry = this.props.configStorage.getRequestData("kunde");
    requestDataKundenEntry.url = requestDataKundenEntry.url + kundenId;
    await this.props.dispatch(kundenActions.fetchEntry(requestDataKundenEntry));
    this.props.navigate(CONFIG.LINK_KUNDENDATEN_EDIT + "/" + kundenId + "/");
  }

  renderAdmin(kunde) {    
    return (
      <div className="container bg-white pt-one pb-one p-md-0" id="admin_render">
        <div className="row" id="admin-contain">
          <div className="float-end col-12" id="admin_btns">
            <button type="button" onClick={e => this.handleEditKunde(e, kunde.id)}
              // to={CONFIG.LINK_KUNDENDATEN_EDIT + `/${kunde.id}/`}
              className="btn btn-primary edit col-5 col-sm-6 col-md-6 col-lg-12"
              id="admin-btn"
            >
              Bearbeiten
            </button>
            <button
              id="admin-btn"
              className="btn btn-danger col-5 col-sm-6 col-md-6 col-lg-12"
              data-bs-toggle="modal"
              data-bs-target="#flipFlop"
              onClick={() => {
                this.setState({
                  id: kunde.id,
                  vorname: kunde.vorname,
                  nachname: kunde.nachname
                });
              }}
            >
              Löschen
            </button>
          </div>
          <div className="bootstrap-iso">
            <div
              className="modal fade"
              id="flipFlop"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="modalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h4 className="modal-title" id="modalLabel">
                      {this.state.vorname}&nbsp;{this.state.nachname}
                    </h4>
                    <button
                      type="button"
                      className="btn btn-default ser-close-modal"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    >
                      <CloseIcon></CloseIcon>
                    </button>
                  </div>
                  <div className="modal-body">
                    Sind Sie sicher, dass Sie diesen Kunden löschen möchten?
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      data-bs-dismiss="modal"
                      onClick={() => { this.deleteKunde(this.state.id); }}
                      className="btn btn-danger"
                    >
                      Löschen
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    >
                      Abbrechen
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  searchSpace = event => {
    let keyword = xss(event.target.value);
    this.setState({ search: keyword });
    let editedKunde = this.props.kundenStorage.editedKunde;
    if (!editedKunde.vorname) {
      this.props.dispatch(kundenActions.resetEditedKunde());
    }
  };

  deleteKunde = async (kundenId) => {
    //#AnpassungKunde
    let requestDataKundenEntry = this.props.configStorage.getRequestData("kunde");
    requestDataKundenEntry.url = requestDataKundenEntry.url + kundenId;
    await axios.delete(requestDataKundenEntry.url);
    let requestDataKundenEntryFetch = this.props.configStorage.getRequestData("kunde");
    this.props.dispatch(kundenActions.fetchEntries(requestDataKundenEntryFetch));
    this.props.navigate(CONFIG.LINK_MITARBEITER_ADD_KUNDEN);
  };

  weiterleitung = async (e, kundenId) => {
    if (e) {
      e.preventDefault();
      if (!kundenId && e.target.dataset.id) {
        kundenId = Number(e.target.dataset.id);
      }
    }
    //#AnpassungKunde
    let requestDataKundenEntry = this.props.configStorage.getRequestData("kunde");
    requestDataKundenEntry.url = requestDataKundenEntry.url + kundenId;
    const kunde = await this.props.dispatch(kundenActions.fetchEntry(requestDataKundenEntry))
      .catch(err => {
        console.error("KundenRecordDataMa weiterleitung", err);
        this.setState({ error: err });
      });
    if (kunde) {
      let weiterleitung = this.props.basketStorage.doShip === "yes" && this.props.mandantStorage.lieferadresseIsEditable()
        ? CONFIG.LINK_KUNDEN_ADDRESSE_MA + `${kundenId}`
        : CONFIG.LINK_FILIALELIEFERUNG;
      this.props.navigate(weiterleitung);
    }
  };

  kunden() {
    let kundenliste = this.props.kundenStorage.kundenliste;
    if (Array.isArray(kundenliste) && kundenliste.length) {
      return kundenliste
        .filter(data => {
          if (!data) return false;
          if (!this.state || this.state.search === null) return true;
          try {
            const regEx = new RegExp(String(this.state.search).trim().toLowerCase(), 'i');
            return !!`${data.vorname} ${data.nachname}`.match(regEx);
          } catch (e) {
            return false;
          }
        })
        .map(data => {
          return (
            <div key={data.id}>
              <ul className="mt-one p-md-0">
                {this.state.search || kundenliste === 1
                  ? <li key={data.id}>
                    <div className="row">
                      <div className="col-12 col-lg-8">
                        <div className="fs-5 col-12" id="list_header">
                          <Link to="#" onClick={this.weiterleitung} data-id={data.id}>
                            {data.vorname}&nbsp;{data.nachname}&nbsp;
                          </Link>
                          <div className="text-break">
                            {data.kundenkonto}
                            &nbsp;&nbsp;
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-lg-4">
                        {this.renderAdmin(data)}
                      </div>
                    </div>
                  </li>
                  : null
                }
              </ul>
            </div>
          );
        });
    }
    return null;
  }

  static getDerivedStateFromProps(props, state) {
    if (!props.kundenStorage) {
      let editedKunde = props.kundenStorage.editedKunde;
      if (!editedKunde && editedKunde.vorname) {
        return { search: `${editedKunde.vorname} ${editedKunde.nachname}` };
      }
    }
    return null;
  }

  async componentDidUpdate(prevProps) {
    if (!isAuthenticated(this.props)) return;

    const prevOver = prevProps.basketStorage.isOverOrderLimit();
    const currOver = this.props.basketStorage.isOverOrderLimit();
    if (!prevOver && currOver) {
      this.props.navigate(this.props.configStorage.getBackToShopLink());
    }

    if (!this.state.isLoggedIn) {
      this.setState({ isLoggedIn: true });
      let requestDataKundenEntry = this.props.configStorage.getRequestData("kunde");
      const loaded = await this.props.dispatch(kundenActions.fetchEntries(requestDataKundenEntry))
        .catch(err => {
          console.error("KundenRecordDataMa error", err);
          this.setState({ error: err, isLoggedIn: false });
        });
      console.log("KundenRecordDataMa update", loaded);
    }
  } 

  render() {
    if (!isAuthenticated(this.props)) {
      return (<MALogin redirect={false}></MALogin>);
    }
   
    return (
      <div id={CONFIG.SHOP_ID} className="if6_outer section if6_section full-height">
        <PageHeader showTimeout={true} />
        <section className="bootstrap-iso" aria-label="Kundendaten">
          <div className="p-one pt-two bg-white">
            <ErrorMessage text="Beim Laden der Kundendaten ist ein Fehler aufgetreten:" error={this.state.error} />
            <div className="row" id="collect_Customer">
              <section className="col col-12 col-md-7 col-lg-7" aria-label="anlegen">
                <div className="">
                  <div className="container" id="kunden_daten">
                    <h2 className="text-h2-secondary mb-one">
                      Kundendaten hinzufügen
                    </h2>
                    <div className="col align-self-center">
                      <KundenCreateMA />
                    </div>
                  </div>{" "}
                </div>
              </section>
              <section className="col-12 col-md-5 col-lg-5" id="search_Kunde" aria-label="auswählen">
                <div className="align-self-center">
                  {" "}
                  <h2 className="text-h2-secondary mb-one">
                    Kunde suchen
                  </h2>
                  <div id="search_Field">
                    <div className="input-group">
                      <input
                        id="search_kunde"
                        type="text"
                        placeholder="Kunden suchen"
                        onChange={e => this.searchSpace(e)}
                        className="form-control form-control-lg"
                      />
                      <div className="input-group-btn">
                        <button className="btn btn-default" aria-label="Suche starten">
                          <SearchIcon />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div>{this.kunden()}</div>
                  <hr />
                </div>
              </section>
            </div>
            <hr />
            <div className="buttons row" id="bottom-nav_Kunde">
              <Link
                to={this.props.configStorage.getBackToShopLink()}
                className="btn btn-info col-6 col-md-4 col-lg-2"
              >
                Zurück zum Shop
              </Link>
              <div className="col-lg-7 col-4" id="kundenav_space"></div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default connect(store => {
  return {
    kundenStorage: store.kundenStorage,
    configStorage: store.configStorage,
    basketStorage: store.basketStorage,
    mandantStorage: store.mandantStorage,
    authenticationStorage: store.authenticationStorage,
    rightStorage: store.rightStorage,
    requiredRageRight: [RAGE_RIGHT.RAGE_BERATER_EINS, RAGE_RIGHT.RAGE_BERATER_ZWEI],
  };
})((props) => {
  const navigate = useNavigate();
  const contextNavigate = props.configStorage.contextNavigate(navigate);
  return <KundenRecordDataMA navigate={contextNavigate} {...props} />;
});
